import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App.tsx';
import '@/styles/global.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
      {process.env.NODE_ENV === 'production' && <Analytics />}
    </StrictMode>
  );
} else {
  console.error('Root element not found');
}
